import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.previouslyChecked = new WeakMap()
  }

  remember(event) {
    const label = event.currentTarget
    const input = label.querySelector('input[type="radio"]')

    this.previouslyChecked.set(label, Boolean(input?.checked))
  }

  toggle(event) {
    const label = event.currentTarget
    const input = label.querySelector('input[type="radio"]')

    if (!input) {
      return
    }

    // Native radio buttons cannot be unchecked by clicking again.
    // Use pointerdown state to avoid clearing a newly selected option.
    const wasChecked = this.previouslyChecked.get(label)
    if (wasChecked) {
      event.preventDefault()
      input.checked = false
      input.dispatchEvent(new Event("change", { bubbles: true }))
    }

    this.previouslyChecked.delete(label)
  }
}
